module.exports = __webpack_public_path__ + "img/icon-donghuajiaoxue-logo.2978c00a.png";